import { motion } from "framer-motion";
import { useScrollAnimation } from "../hooks/useScrollAnimation";

const stats = [
  {
    value: "200+", label: "Projects delivered", category: "Engagements",
    desc: "AI products, platforms and internal tools shipped to production since 2018.",
  },
  {
    value: "50+", label: "Team members", category: "Our team",
    desc: "Engineers, ML practitioners and cloud architects working in dedicated pods of 4–6.",
  },
  {
    value: "90", label: "Avg. days to launch", category: "Delivery",
    desc: "Median time from kickoff workshop to first production deployment.",
  },
  {
    value: "98%", label: "Client retention", category: "Partnership",
    desc: "Clients who return for a second engagement or move to a long-term retainer.",
  },
];

function FadeUp({ children, delay = 0, className = "" }) {
  const [ref, visible] = useScrollAnimation(0.1);
  return (
    <motion.div ref={ref}
      initial={{ opacity: 0, y: 24 }}
      animate={visible ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.55, delay, ease: "easeOut" }}
      className={className}>
      {children}
    </motion.div>
  );
}

export default function About() {
  const [sRef, sVis] = useScrollAnimation(0.05);

  return (
    <section id="about" className="relative py-24 bg-paper overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="flex items-start justify-between mb-10">
          <FadeUp>
            <span className="eyebrow">01 — By the numbers</span>
          </FadeUp>
          <FadeUp delay={0.05} className="hidden sm:block">
            <span className="text-xs text-ink-400">Snapshot — 2026</span>
          </FadeUp>
        </div>

        <FadeUp delay={0.1} className="mb-16">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold leading-[0.98] tracking-[-0.03em] text-ink max-w-2xl">
            What we've built for our clients.
          </h2>
        </FadeUp>

        <div ref={sRef} className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-12">
          {stats.map(({ value, label, category, desc }, i) => (
            <motion.div key={label}
              initial={{ opacity: 0, y: 18 }}
              animate={sVis ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: i * 0.08 }}
            >
              <div className="border-t-2 border-ink pt-4 mb-4">
                <div className="text-4xl md:text-5xl font-bold tracking-tight text-ink mb-1">
                  {value}
                </div>
                <div className="text-sm text-ink-500 font-medium">{label}</div>
              </div>
              <div className="eyebrow mb-2">{category}</div>
              <p className="text-xs text-ink-500 leading-relaxed">{desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
